"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckBox = exports.CSS = void 0;
const mithril_1 = require("../../mithril");
const icon_1 = require("../icon");
const icons_1 = require("../icon/icons");
const theme_1 = require("../theme");
exports.CSS = {
    container: 'c-CheckBox',
    isSelected: 'c-CheckBox--selected',
    isIndeterminate: 'c-CheckBox--indeterminate',
    isDisabled: 'c-CheckBox--disabled',
};
(0, theme_1.addStyles)({
    [exports.CSS.container]: {
        userSelect: 'none',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden',
        color: theme_1.DefaultTheme.font.color.supporting,
    },
    [exports.CSS.isSelected]: {
        color: theme_1.DefaultTheme.font.color.link,
    },
    [exports.CSS.isIndeterminate]: {
        color: theme_1.DefaultTheme.font.color.link,
    },
    [exports.CSS.isDisabled]: {
        color: theme_1.DefaultTheme.font.color.disabled,
    },
});
exports.CheckBox = {
    view(state) {
        const isSelected = state.isSelected() === true;
        let className = exports.CSS.container;
        let materialIcon = icons_1.MaterialIcon.CHECK_BOX;
        if (isSelected) {
            className += ' ' + exports.CSS.isSelected;
            materialIcon = icons_1.MaterialIcon.CHECK_BOX_SELECTED;
        }
        else if (state.isIndeterminate != null && state.isIndeterminate()) {
            className += ' ' + exports.CSS.isIndeterminate;
            materialIcon = icons_1.MaterialIcon.CHECK_BOX_INDETERMINATE;
        }
        if (state.isDisabled) {
            className += ' ' + exports.CSS.isDisabled;
        }
        return (0, mithril_1.m)('div', {
            className,
            onclick: !state.isDisabled
                ? (ev) => {
                    ev.stopPropagation();
                    state.setSelected(!isSelected);
                }
                : null,
        }, icon_1.Icon.view(materialIcon));
    },
};
//# sourceMappingURL=input.checkbox.js.map